import React, { FC, useContext } from 'react'

import { clsx } from 'clsx'
import { useFormContext } from 'react-hook-form'

import useEvent from 'Hooks/useEvent'
import Amex from 'Icons/shop/cards/amex.svg'
import MasterCard from 'Icons/shop/cards/mastercard.svg'
import Visa from 'Icons/shop/cards/visa.svg'
import ApplePay from 'Icons/shop/payment_methods/apple-pay.svg'
import GooglePay from 'Icons/shop/payment_methods/google-pay.svg'
import { StepContext } from 'Pages/Checkout/Form'
import { CardBrands, PaymentMethods, ShopCustomerCard } from 'Types'

import { usePayment } from '../../Provider'

const TITLE = {
  [PaymentMethods.APPLE_PAY]: 'Apple Pay',
  [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
}

const ICONS = {
  [PaymentMethods.APPLE_PAY]: <ApplePay key={PaymentMethods.APPLE_PAY} />,
  [PaymentMethods.GOOGLE_PAY]: <GooglePay key={PaymentMethods.GOOGLE_PAY} />,
  [CardBrands.AMERICAN_EXPRESS]: <Amex key={CardBrands.AMERICAN_EXPRESS} />,
  [CardBrands.MASTERCARD]: <MasterCard key={CardBrands.MASTERCARD} />,
  [CardBrands.VISA]: <Visa key={CardBrands.VISA} />,
  allBrands() {
    return [this.VISA, this.MASTERCARD, this.AMERICAN_EXPRESS]
  },
}

interface Props {
  card?: ShopCustomerCard
  hasCards?: boolean
  paymentMethod: PaymentMethods
  selected: boolean
}

const PaymentOption: FC<Props> = ({ children, card, hasCards, paymentMethod, selected }) => {
  const { checkouting } = useContext(StepContext)
  const { gateway, tokenizing } = usePayment()
  const { field } = gateway
  const { setValue } = useFormContext()
  const cardId = card?.id
  const isPaymentCard = paymentMethod === PaymentMethods.CARD

  const handleSelect = useEvent(() => {
    setValue(`${field}.paymentMethod`, paymentMethod)
    setValue(`${field}.payByEnteredCard`, !cardId)
    setValue(`${field}.sourceId`, cardId)
  })

  const title = isPaymentCard
    ? card
      ? `•••• ${card.last4}`
      : hasCards
        ? 'Add card'
        : 'Credit card'
    : TITLE[paymentMethod]

  return (
    <div className="checkout-option  checkout-option_payment">
      <div
        className={clsx('checkout-option__control', {
          ['checkout-option__control_selected']: selected,
          ['checkout-option__control_loading']: selected && (checkouting || tokenizing),
        })}
        onClick={handleSelect}
      >
        <div className="checkout-option__inner">
          <div
            className={clsx('checkout-option__payments', {
              ['checkout-option__payments_cards']: isPaymentCard,
            })}
          >
            {isPaymentCard
              ? card
                ? ICONS[card.cardBrand]
                : ICONS.allBrands().map((icon) => icon)
              : ICONS[paymentMethod]}
          </div>
          <span className="ml-3">{title}</span>
        </div>

        {!selected || !children ? null : <div className="my-2">{children}</div>}
      </div>
    </div>
  )
}

export default PaymentOption
